'use client';
import React from 'react';
import styled from '@benzinga/themetron';
import { AltOfferingCompany } from '@benzinga/alts-manager';
import { sanitizeHTML } from '@benzinga/frontend-utils';

interface PlatformDetailsProps {
  company: AltOfferingCompany;
}

export const PlatformDetails: React.FC<PlatformDetailsProps> = ({ company }) => {
  const [showDisclosure, setShowDisclosure] = React.useState(false);

  const historyReturnLabel = company?.slug === 'masterworks' ? 'Historical Price Appreciation' : 'Historical Returns';

  const platformDetails = [
    { label: historyReturnLabel, value: company.historicReturns },
    { label: 'Investment Types', value: company.investmentTypes },
    { label: 'Property Types Available', value: company.propertyTypesAvailable },
    { label: 'Minimum Investment', value: company.minimumInvestment },
    // { label: 'Investor Fees', value: company.investor_fees },
  ];

  const collapseDisclosure = () => {
    setShowDisclosure(!showDisclosure);
  };

  return (
    <PlatformDetailsContainer className="platform-details-container">
      {company.description && (
        <div className="description-block">
          <h5>Description</h5>
          <p dangerouslySetInnerHTML={{ __html: sanitizeHTML(company.description) }}></p>
        </div>
      )}
      {platformDetails && platformDetails.length > 0 && (
        <div className="platform-details-block">
          <h4 className="mb-2">Platform Details</h4>
          <ul className="platform-details-list">
            {platformDetails.map(item => {
              if (item.value !== '') {
                return (
                  <li key={item.label}>
                    <span>{item.label}</span>
                    <span>{item.value ?? '–'}</span>
                  </li>
                );
              } else {
                return null;
              }
            })}
          </ul>
          <div>
            {!showDisclosure && company.companyDisclosure && (
              <span className="text-xs cursor-pointer text-blue-500 hover:text-blue-400" onClick={collapseDisclosure}>
                *See important disclosures
              </span>
            )}
            {showDisclosure && (
              <>
                <span className="text-xs cursor-pointer text-blue-500 hover:text-blue-400" onClick={collapseDisclosure}>
                  Hide disclosures
                </span>
                <div className="alts_disclosure-wrapper mt-2">
                  <p className="text-sm font-bold m-0">
                    Disclosure:{' '}
                    <span
                      className="m-0 font-normal break-words"
                      dangerouslySetInnerHTML={{ __html: sanitizeHTML(company.companyDisclosure || '') }}
                    ></span>
                  </p>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </PlatformDetailsContainer>
  );
};

const PlatformDetailsContainer = styled.div`
  &.platform-details-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-right: 25px;

    .description-block {
      p {
        line-height: 1.5;
        &:last-of-type {
          margin-bottom: 0;
        }
      }
    }

    > div {
      font-size: 14px;
      width: 100%;
      background: #ffffff;
      padding: 20px;
      margin-bottom: 25px;
      border: 1px solid #ebebeb;
      border-radius: 5px;

      h5 {
        font-weight: 600;
        color: #242429;
        margin-bottom: 0.8rem;
        letter-spacing: 0;
        font-size: 14px;
      }

      .platform-details-list {
        display: flex;
        flex-direction: column;

        li {
          display: flex;
          justify-content: space-between;
          padding-bottom: 8px;
          box-sizing: border-box;
          padding-top: 8px;
          border-bottom: 1px solid rgba(0, 0, 0, 0.1);
          span {
            &:last-of-type {
              padding-left: 6px;
            }
          }

          &:first-child {
            padding-top: 0;
          }

          &:last-of-type {
            border-bottom: none;
          }
        }
      }
    }

    p {
      color: #242429;
      font-size: 14px;
      line-height: 26px;
    }
    .alts_disclosure-wrapper {
      p {
        line-height: 1.3;
        span {
          font-size: 11px;
        }
      }
    }
  }
`;
